/*
 * @Author: Dom
 * @Date: 2022-06-20 15:58:47
 * @LastEditTime: 2022-07-07 17:30:44
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\utils\gotoemail.ts
 */
export const emailList = {
    '@163.com': 'https://email.163.com',
    '@163.com.vip': 'https://vip.163.com',
    '@ym.163.com': 'https://ym.163.com',
    '@aliyun.com': 'https://@aliyun.com',
    '@qiye.aliyun.com': 'https://qiye.aliyun.com',
    '@126.com': 'https://www.126.com',
    '@qq.com': 'https://mail.qq.com',
    '@sohu.com': 'https://mail.sohu.com',
    '@sina.com.cn': 'https://mail.sina.com.cn',
    '@tom.com': 'https://mail.tom.com',
    '@yeah.net': 'https://www.yeah.net',
    '@21cn.com': 'https://mail.21cn.com',
    '@outlook.com': 'https://www.outlook.com',
    '@189.cn': 'https://mail.189.cn',
    '@10086.cn': 'https://mail.10086.cn',
    '@188.com': 'https://www.188.com',
    '@wo.cn': 'https://mail.wo.cn',
    '@qq.com.vip': 'https://exmail.qq.com',
    '@263.net': 'https://www.263.net',
    '@qiye.163.com': 'https://qiye.163.com',
}

export function gotoEmail(val:string){
    window.open(emailList[val])
}
